import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { connect } from 'react-redux';
import { change, formValues } from 'redux-form';
import { flowRight } from 'lodash/fp';

import Icon from 'common/components/Icon';
import GridRadioChoices from '../../form/GridRadioChoices';
import NextButton from '../../FormButtons/buttons/NextButton';
import withRouter from '../../withRouter';
import RipForm from '../Form';

import './choiceResponse.scss';
import './processedRequest.scss';

const relaunchChoices = { yes: 'OUI', no: 'NON' };

// Bouton du footer : NON retourne à la liste des rips, OUI donne accès au formulaire de préconisation
const RelaunchButton = flowRight([
    withRouter,
    formValues('relaunch'),
    connect(null, { confirmRelaunch: (recommendationId) => change('cif-approval', 'relaunchConfirmed', recommendationId) }),
])(({ relaunch, confirmRelaunch, params: { recommendationId }, nextButtonContent, ...props }) => (
    'yes' === relaunch ? (
        <div className="formNextAction">
            <button type="button" onClick={() => confirmRelaunch(recommendationId)}>
                {nextButtonContent}&nbsp;
                <Icon icon="angle-right" />
            </button>
        </div>
    ) : (
        <NextButton {...props} nextButtonContent={nextButtonContent} nextRedirectTo="/" />
    )
));

// Page affichée à la place du formulaire de validation CIF quand la demande a déjà été traitée :
// refusée (simple message) ou validée avec une enveloppe en composition (question de relance).
const ProcessedRequest = ({ ripId, isRefused, ...props }) => (
    <RipForm
        {...props}
        id={ripId}
        hideBackButton
        nextButtonContent={isRefused ? 'Retourner vers la liste des Rips' : 'Valider'}
        nextRedirectTo={isRefused ? '/' : undefined}
        nextButtonComponent={isRefused ? undefined : RelaunchButton}
    >
        <div className={classNames('processed-request choice-response', { refused: isRefused })}>
            {isRefused ? (
                <div className="refused-message">
                    La demande a été <span style={{ fontWeight: 'bold', textDecoration: 'underline' }}>invalidée</span> et ne peut être retraitée, <br />
                    contactez le conseiller pour refaire une nouvelle demande.
                </div>
            ) : (
                <div className="relaunch-question">
                    <p className="relaunch-text">Le dossier est déjà initialisé, souhaitez-vous vraiment le relancer ?</p>
                    <GridRadioChoices choices={relaunchChoices} name="relaunch" className="double" />
                </div>
            )}
        </div>
    </RipForm>
);

ProcessedRequest.propTypes = {
    ripId: PropTypes.string.isRequired,
    isRefused: PropTypes.bool,
};

ProcessedRequest.defaultProps = {
    isRefused: false,
};

export default ProcessedRequest;
